var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',{directives:[{name:"chat-scroll",rawName:"v-chat-scroll"}]},_vm._l((_vm.getByID[_vm.torrentID]),function(line){return _c('p',{key:line.index,domProps:{"innerHTML":_vm._s(_vm.colorLine(line.data))}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }